import styled from "styled-components";

export const TagContainer = styled.div`
  display: inline-flex;
  width: auto;
`;

